"use strict";
import { parsePath } from "history/lib/PathUtils";
import { stringify } from "query-string";
export default function locationDescriptor(path, query = null, state = null) {
  const { pathname, search, hash } = parsePath(path);
  const queryString = query ? stringify(query).replace(/%20/g, "+") : "";
  return {
    pathname,
    search: queryString ? `${search}${search ? "&" : "?"}${queryString}` : search,
    hash,
    state
  };
}
